import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ToastController } from '@ionic/angular';
import { AuthenticateService } from './services/authenticate.service';
import { Storage } from '@ionic/storage-angular';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(
    private router: Router,
    private toastController: ToastController,
      private storage: Storage,
      private  auth:AuthenticateService
  ) {}

  async showSessionExpiredToast() {
    const toast = await this.toastController.create({
      message: 'Tu sesión ha sido cerrada. Vuelve a iniciar sesión.',
      duration: 3000,
      color: 'danger',
      position: 'bottom'
    });
    await toast.present();
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        console.log('interceptr error',error)
        if (error.status === 401) {
          localStorage.removeItem('token');
  
          this.cerrarSesionYRedirigir();
        }
  
        return throwError(() => error);
      })
    );
  }

  private async cerrarSesionYRedirigir() {
    await this.showSessionExpiredToast();
  
    await this.storage.remove('token');
    await this.storage.remove('identity');
    await this.storage.clear();
  
    this.auth.token = null;
    this.auth.identity = null;
  
    this.router.navigateByUrl('/login');
  }
}